<template>
  <div id="app" >
    <headerNew></headerNew>

    <div class="content-block">
      <keep-alive>
        <router-view
          :key="$route.fullPath" v-if="$route.meta.keepAlive"
        />
      </keep-alive>
      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
    </div>

    <!-- <footerNew></footerNew> -->
  </div>
</template>

<script>

import headerNew from "./components/header/headerNew.vue";
import footerNew from "./components/footer/footerNew.vue";

export default {
  name: "app",
  components: {
    headerNew,
    footerNew
  },
  data() {
    return {
      
    }
  },
  computed: {
  },
  mouted(){

  },
  beforeMount() {  
    
  },
  methods: {

  }
};
</script>
<style>
html,
body {
  width: 100%;
  /* background: #232323; */
}
</style>
<style lang="scss" scoped>
.content-block {
  width: 100%;
  margin: auto;
  //min-height: calc(100vh - 79px);
}
.min-bg {
   min-width: 1200px;
   width: 100%;
  
}
.h-light {
  color: #d9a73a;
}
.lose-connection {
  position: fixed;
  z-index: -1;
  left: 20px;
  right: 20px;
  top: 200px;
  text-align: center;
  background-color: rgba(222, 177, 66, 0.64);
  line-height: 100px;
  font-size: 24px;
  color: #ffffff;
  border-radius: 2px;
  opacity: 0;
  transform: translateY(-200px);
  transition: transform 0.3s;
  &.active {
    z-index: 3;
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
